const menuListData = {
  state: {
    menuList: null,
    date: null || localStorage.getItem('setDate'),
    activeTabs: localStorage.getItem('activeTabs') || '/'
  },
  actions: {
    setMenuListData: function (context, menuList) {
      context.state.menuList = menuList
    },
    setDate: function (context, setDate) {
      context.state.date = setDate
    }
  },
  mutations: {
    setActiveTabs (state,key) {
      state.activeTabs = key
    }
  }
}


export default menuListData
